import {h} from "preact";
import {GlobalsContext} from "../../AppContext";
import {useContext, useEffect} from "preact/hooks";
import style from "./TooltipComponent.css";
import CloseTooltip from "../CloseTooltip/CloseTooltip";
import clsx from "clsx";

const TooltipComponent = ({ tooltipTitle }) => {
    const tooltip = tooltipTitle || "Отвечу на любые дополнительные вопросы по учебе";
    const { tooltipClose, setTooltipClose } = useContext(GlobalsContext);

    useEffect(() => {
        const isTooltipClosed = localStorage.getItem("tooltipClosed") === "true";

        setTooltipClose(isTooltipClosed);
    }, []);

    if (tooltipClose) return null;

    return (
        <div className={clsx(style.root)}>
            <span>{tooltip}</span>
            <CloseTooltip />
        </div>
    );
};

export default TooltipComponent;
